<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                            <!-- <Button v-if="this.$IS_PRINT_DOCUMENT == 'FALSE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="downloadPrint" /> -->
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12;" v-if="dataDocument">
                   <thead>
                         <tr style="text-align:center;height: 60px;">
                            <td colspan="2"> 
                                <span class="title">
                                </span>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th colspan="3"><p class="year" style="text-align: right;">{{ dataDocument.location +", " + this.$formatDateName(dataDocument.Doc_Date)}}</p></th>
                        </tr>
              
                       <tr class="th">
                        <th colspan="3"><p style="font-size:20px"><u>BERITA ACARA INSTRUKSI KERJA</u><br/>
                            <span style="font-size:15px;" v-if="dataDocument">No. Document: {{dataDocument.Doc_No}}</span></p></th>
                       </tr>
                     
                  
                    
                        <tr>
                            <td colspan="3"><p align="justify" class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bersama dengan ini kami memberikan instruksi kepada <span style="font-weight:bold;color:black">{{ dataDocument != null ? dataDocument.contractor : "" }} </span> untuk segera memulai pekerjaan "{{ dataDocument != null ? dataDocument.Deskripsi_Pekerjaan : "" }}"
                            berdasarkan, </p></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <table class="widht1">
                                    <tbody>
                                        <tr>
                                            <td>SPO</td>
                                            <td>: {{dataDocument.No_SPO !=null ? dataDocument.No_SPO : ""}}</td>
                                            <td>Nilai Kontrak</td>
                                            <td>: {{dataDocument.ContractValue}}</td>
                                        </tr>
                                        <tr>
                                            <td>No. WO</td>
                                            <td>: {{dataDocument.No_WO !=null ? dataDocument.No_WO : ""}}</td>
                                            <td>Budget</td>
                                            <td>: {{dataDocument.Budget !=null ? dataDocument.Budget : ""}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <ol class="ol" style="margin-left:-12px;list-style-type: none;"  v-if="dataDocument">
                                        <li  v-for="item in dataDocument.Reasons" :key="item.id"> {{ item.Description }}</li>
                                     </ol>
                                </div>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="3">
                                <br/>
                                <div class="widht1">
                                   <table>
                                        <tbody>
                                            <tr>
                                                <td>Tanggal Mulai Pekerjaan</td>
                                                <td>: {{dataDocument!=null ? this.$formatDate(dataDocument.Tanggal_Mulai_Pekerjaan) :""}}</td>
                                            </tr>
                                            <tr>
                                                <td>Tanggal SPO</td>
                                                <td>: {{dataDocument!=null ? this.$formatDate(dataDocument.Tanggal_SPO) :""}}</td>
                                            </tr>
                                            <tr>
                                                <td>Waktu Penyelesaian Pekerjaan</td>
                                                <td>: {{dataDocument!=null ? dataDocument.Waktu_Penyelesaian_Pekerjaan :""}} Hari</td>
                                            </tr>
                                        </tbody>
                                   </table>
                                   <br/>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <p style="text-align: justify;" v-if="dataDocument"><span style="color:black;font-weight:bold">Dengan Scope Pekerjaan sebagai berikut (wajib dirincikan)</span>:<br/>
                                    </p>  
                                    <ol class="ol" style="margin-left:-12px;" v-if="dataDocument">
                                       <li style="list-style-type: none;" v-for="item in dataDocument.Scopes" :key="item.id"> {{ item.Description }}</li>
                                    </ol>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <br/>
                                <div class="widht1">
                                    <p style="text-align: justify;"><span style="color:black;font-weight:bold;">Kewajiban kontraktor</span>:
                                    </p> 
                                    <ol class="ol">
                                        <li>Membuat ijin permit kerja, melakukan mob- demob material dan alat kerja</li>
                                        <li>Melakukan house keeping sebelum dan sesudah bekerja</li>
                                        <li>Mengikuti semua regulasi yang berlaku selama bekerja di area project Wilmar</li>
                                    </ol>
                                </div>
                                <br/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <p style="text-align: justify;"><span style="color:black;font-weight:bold;">Berita acara menyatakan bahwa</span>:</p>
                                    <ol class="ol">
                                        <li>Pihak Wilmar telah melakukan serah terima lahan kepada Kontraktor untuk dapat melaksanakn pekerjaan tersebut di atas sesuai dengan design, BoQ, dan durasi waktu yang sudah disepakati</li>
                                        <li>Lahan/Area pekerjaan akan menjadi tanggung jawab penuh Kontraktor selama belum BAST Retesi (Masa pemeliharaan berakhir)</li>
                                        <li>Kontraktor dapat memulai pekerjaan tersebut diatas sebelum SPO/SPK diterima</li>
                                    </ol>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3"><p align="justify" class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Demikian berita acara ini kami buat sebenar-benarnya, agar bisa digunakan seperlunya.</p></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <table class="widht1">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" style="width:50%">
                                                <div style="text-align:center;float:Left;">
                                                    <p>Dibuat Oleh,<br/>
                                                        <span>{{dataDocument.comp1}}</span>
                                                    </p>
                                                    <div v-if="!dataDocument.Appr_Name1"><br/><br/><br/></div>
                                                    <p  v-if="dataDocument.Appr_Name1">
                                                       <span class="fontsign">{{ dataDocument.Appr_Name1 }} </span> 
                                                    </p>
                                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                                    <hr>
                                                    <p>
                                                        <span>{{dataDocument.Appr_As1}}</span>
                                                    </p> 
                                                </div>

                                            </td>
                                        
                                            <td colspan="2" style="width:50%">
                                                <div style="text-align:center;float:right;">
                                                    <p>Disetujui Oleh,<br/>
                                                        <span v-if="dataDocument">{{dataDocument.comp2}}</span>
                                                    </p> 
                                                    <div v-if="!dataDocument.Appr_Name2"><br/><br/><br/></div>
                                                    
                                                    <p v-if="dataDocument.Appr_Name2">
                                                        <span class="fontsign">{{ dataDocument.Appr_Name2 }} </span> 
                                                     </p>
                                                     <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                                    <hr>
                                                    <p> 
                                                        <span>{{dataDocument.Appr_As2}}</span>
                                                    </p> 
                                                </div>
                                            </td>
                                            
                                        </tr>
                                        <tr>
                                            <td colspan="4">
                                                <div style="text-align:center;">
                                                    <p>Diketahui Oleh,<br/>
                                                        <span>{{dataDocument.comp3}}</span>
                                                    </p>
                                                    <div v-if="!dataDocument.Appr_Name3"><br/><br/><br/></div>
                                                    <p  v-if="dataDocument.Appr_Name3">
                                                       <span class="fontsign">{{ dataDocument.Appr_Name3 }} </span> 
                                                    </p>
                                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate3)}}</span>
                                                    <hr>
                                                    <p>
                                                        <span>{{dataDocument.Appr_As3}}</span>
                                                    </p> 
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                        <tr style="height:20px;">
                            <td></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT || dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td style="color: #8e8158e4;font-size:8.9px;">
                            </td>
                            <td>
                                <VueQrcode id="qr" :value="valueLink" style="width:70px;float:right;"></VueQrcode>
                            </td>
                        </tr>
                   
                        <tr>
                            <td colspan="3" v-if="dataDocument.is_aproved">
                                <p style="font-size:9px;">
                                    <b>
                                        {{ 
                                            this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                   
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {

        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgcontractor : "",
        signPM : "",
        signCP : "",
        signCont : "",
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath,
        signby :  ""
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; //${ data!=null && data.Rev != 0 ? '- Document Rev ' + data.Rev : ""}
        return this.signby;
    },  
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                //var qr = document.getElementById('qr').src;
                //const [mimeType, base64Data] = dataURL.split(';base64,');
                this.$axios.get(this.$API_URL + "BaWithSpo/" + "downloadprint", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.$route.query.id,
                    linqr : link,
                    company : this.dataDocument.company,
                    contractor : this.dataDocument.contractor,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    //const url = window.URL.createObjectURL(new Blob([response.data]));
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
                    
                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    // Create an object URL from the Blob
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    //this.$refs.pdfPreview.src = url;
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', fileName);
                    // document.body.appendChild(link);
                    // link.click();
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                    //self.showAssignModal = false;
                });
        },

    formatRupiah(number) {
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });

    return formatter.format(number);
    },
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/BaWithSPO/Index" });
    },

    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.round(scrollHeight / window.outerHeight);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            if(i != 0){
                pageNumberDiv.style.top = "calc((100% - 10mm + 30px) * " + (i+1)+ ")";
            }else{
                pageNumberDiv.style.top = "calc((100% - 10mm + 22px) * " + (i+1)+ ")";
            }
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            //pageNumberDiv.style.marginBlockStart = "30px"
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        // let doc_width = 9.5;
        // let doc_height = 5.5;
        // let dpi = 94;
        // let img_width = doc_width * dpi;
        // let img_height = doc_height * dpi;
        // let win_width = img_width;
        // let win_height = img_height;
        // let html2canvasOpts = {
        //     dpi: 360 * 180,
        //     scale: 8,
        //     width: img_width,
        //     windowWidth: win_width,
        //     windowHeight: doc_height * 96 - 3,
        //     letterRendering: true,
        //     allowTaint: true
        // };
        // let jsPDFOpts = {
        //     orientation: 'portrait',
        //     unit: 'in',
        //     format: "a4"
        // };

        // html2pdf(this.$refs.document, {
        //     margin: [0.10, 0.10, 0.10, 0.10],
        //     filename: this.title,
        //     image: { type: 'jpeg', quality: 1 },
        //     html2canvas: html2canvasOpts,
        //     jsPDF: jsPDFOpts,

        // })

        html2pdf(this.$refs.document, {
            margin: [1,1,1,1],
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "BaWithSpo/getDataDoc/"+ this.type + "/" +  this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgcontractor = data.imgcontractor;
                self.signPM = data.signPM;
                self.signCP = data.signCP;
                self.signCont = data.signCont;
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.$emit('unblock-ui');
            });
        },
},
computed:{
},   
created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;
    this.getData();
},
}
</script>
<style> 
@media print {
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
    }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}

#apps{
    width: 80%;
}

</style>
<style scoped>
@page {
    size: A4 portrait;
    margin: 10mm;
}
@media print {
    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }
}

.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top: 1.5px dotted black;
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
}

#toolbar{
    max-height: 90px;
}

.title{
    font-size: 30px;
    color: #8e8158e4;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
  
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 90%; /* Add a width to demonstrate text wrapping */
    margin: 0 auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>